module.exports = __webpack_public_path__ + "img/Villa_Borna_8.414dcc31.jpg";